import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';
import { ENUM_STATUS_PRE_REGISTRATION } from '@/_features/motoboys/constants';
import styles from './styles.module.scss';

interface DisapprovalLabelProps {
  disapprovalStatus: ENUM_STATUS_PRE_REGISTRATION;
  isAbsoluteStyle?: boolean;
}

export const TRANSLATE_STATUS: Partial<
  Record<ENUM_STATUS_PRE_REGISTRATION, string>
> = {
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK]: 'Cadastro reprovado',
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_PEDING_RESEND_DOCUMENTATION]:
    'Cadastro reprovado - Pendente de aportar nova documentação',
  [ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED]:
    'Cadastro pendente de validação',
  [ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION]:
    'Cadastro pendente de validação',
  [ENUM_STATUS_PRE_REGISTRATION.DELETED]: 'Usuário excluído',
};

function DisapprovalLabel({
  disapprovalStatus,
  isAbsoluteStyle = false,
}: DisapprovalLabelProps) {
  const navigate = useNavigate();
  const { motoboyId } = useParams<{ motoboyId: string }>();

  const isReproved =
    disapprovalStatus === ENUM_STATUS_PRE_REGISTRATION.REPROVED_FOR_CHECK;

  const isDeleted = disapprovalStatus === ENUM_STATUS_PRE_REGISTRATION.DELETED;

  const isNewDoccument =
    disapprovalStatus ===
      ENUM_STATUS_PRE_REGISTRATION.NEW_REGISTER_PEDING_VALIDATION ||
    disapprovalStatus ===
      ENUM_STATUS_PRE_REGISTRATION.REPROVED_NEW_DOCUMENTATION_PROVIDED;

  const handleClick = () => {
    if (isNewDoccument && motoboyId) {
      return navigate(`/precadastro/entregadores/${motoboyId}`);
    }
  };

  return (
    <div
      data-testid="disapproval-label"
      className={classNames(
        styles.container,
        !isAbsoluteStyle && styles.absoluteContainer,
        isNewDoccument && styles.newDocument,
        isReproved && styles.reproved,
        isDeleted && styles.deleted,
      )}
      onClick={handleClick}
    >
      <p className={styles.label}>{TRANSLATE_STATUS[disapprovalStatus]}</p>
    </div>
  );
}

export { DisapprovalLabel };
